import React from 'react';
import styled from 'styled-components';
import VideoSelect from '../../../components/molecule/FormFields/VideoSelect';
import Icon from '@material-ui/core/Icon';
import * as apiServices from '../../../services/apiServices';
import { connect } from 'react-redux';
import { bindActionCreators} from 'redux';
import { setGlobalLoadingSpinner } from '../../../modules/GlobalUI';
import { startPolling } from '../../../modules/UploadQueue';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import FileUploader from '../../../components/atomic/Inputs/FileUploader';
import {
    ACCEPTED_VIDEO_FORMATS,
    DEFAULT_EXERCISE_VIDEO_ORIENTATION,
    STREAMING_STATUS,
} from '../../../core/constants';

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
  max-width: 800px;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 10px;
`
const StretchContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`
const VideoContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 200px;
  margin-right: 10px;
  margin-top: 10px;
  overflow: hidden;
`

const UploadProgressContainer = styled.div`
  margin-top: 8px;
  width: 100%;
`

const PlaceholderIconStyled = styled(Icon)`
  font-size: 40px;
  margin-bottom: 8px;
`

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 160px;
`

const WelcomeContainerStyled = styled.div`
  display: flex;
`
const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const OptionSelect = styled.div`
  direction: rtl;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
`
const UploadButtonContainer = styled.div`

`
const VideoSelectStyled = styled(VideoSelect)`
  direction: ltr;
  display: flex;
  width: 100%;
`


class MyForm extends React.Component {
    constructor() {
        super()
        this.state = {
            submitted: false,
            isSubmitting: false,
            videoUploadProgress: 0,
            video: null,
        }
    }


    componentDidMount(){
        apiServices.getWelcomeVideo()
            .then(data => {
                this.setState({ video: {...data}});
            });
    }

    componentDidUpdate(prevProps, prevState) {
        const { welcomeVideo } = this.props.welcomeVideoState;
        const { welcomeVideo: prevWelcomeVideo } = prevProps.welcomeVideoState;

        if (welcomeVideo !== prevWelcomeVideo) {
            this.setState(prevState => ({ ...prevState, video: { ...welcomeVideo} }));
        }
    }

    videoUploadFinished = ({ awsUrl }) => {
        const { startPolling, values } = this.props;

        apiServices.addExerciseVideo({
            exercise: values?.id,
            streaming_status: STREAMING_STATUS.PROCESSING,
            subtitle: '',
            video: awsUrl,
            video_orientation: DEFAULT_EXERCISE_VIDEO_ORIENTATION,
        }).then(data => {
            this.setState({ videoUploadProgress: 0 });
            startPolling({
                id: values?.id,
                videoId: data.id,
                streaming_status: STREAMING_STATUS.PROCESSING,
                uploadType: 'welcomeVideo'
            });
        });
    }
    updateVideoUploadProgress = (videoUploadProgress) => {
        this.setState({ videoUploadProgress });
    }

    render () {
        const {
            authState: { userData },
            welcomeVideoState
        } = this.props
        const {
            videoUploadProgress,
            video,
        } = this.state;
        let welcomeVideo =  welcomeVideoState.welcomeVideo ?  welcomeVideoState.welcomeVideo : video;

        const videoPlaceholderText = 'No Video';

        return (
            <WelcomeContainerStyled>
                <Container>
                    <Wrapper>
                        <StretchContainer>
                            <VideoContainer>
                                <UploadButtonContainer>
                                    <FileUploader
                                        accept={ACCEPTED_VIDEO_FORMATS}
                                        buttonText="Upload Video"
                                        fileType="exerciseVideo"
                                        fullWidth
                                        metadata={{ trainer_id: userData.user_id.toString() }}
                                        onFinish={this.videoUploadFinished}
                                        onProgress={this.updateVideoUploadProgress}
                                        variant='contained'
                                    />
                                </UploadButtonContainer>
                                <OptionWrapper>
                                    <OptionSelect>
                                        {
                                            (welcomeVideo && welcomeVideo.streaming_status === STREAMING_STATUS.COMPLETE) ? (
                                                <VideoSelectStyled
                                                    processing={welcomeVideo.streaming_status === STREAMING_STATUS.PROCESSING}
                                                    thumbnail={welcomeVideo.thumbnail}
                                                    video={welcomeVideo.streaming_video}
                                                />
                                            ) : (
                                                <ImageWrapper style={{opacity: 0.3}}>
                                                    <PlaceholderIconStyled>photo</PlaceholderIconStyled>
                                                    {videoPlaceholderText}
                                                    {
                                                        video?.streaming_status === STREAMING_STATUS.PROCESSING &&
                                                        <CircularProgress />
                                                    }
                                                </ImageWrapper>
                                            )
                                        }
                                    </OptionSelect>
                                </OptionWrapper>
                                { videoUploadProgress > 0 && (
                                    <UploadProgressContainer>
                                        <LinearProgress variant="determinate" value={videoUploadProgress} />
                                    </UploadProgressContainer>
                                )}
                            </VideoContainer>
                        </StretchContainer>
                    </Wrapper>
                </Container>
            </WelcomeContainerStyled>
        );
    }
};

function mapStateToProps(state) {
    return {
        authState: state.authState,
        welcomeVideoState: state.welcomeVideoState
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setGlobalLoadingSpinner: setGlobalLoadingSpinner,
        startPolling: startPolling,
    }, dispatch)
}

export default connect(mapStateToProps,mapDispatchToProps)(MyForm);